import MuiChip, { ChipProps as MuiChipProps } from "@mui/material/Chip";

import { TestProps } from "shared/types";

interface Props extends MuiChipProps, TestProps {}

type AllowedChipVariants = Extract<Props["variant"], "filled">;
export const CHIP_COLORS = [
  "default",
  "primary",
  "info",
  "success",
  "warning",
  "error",
  "ai",
  "neutral",
] as const;

export type ChipColor = (typeof CHIP_COLORS)[number];

type ChipProps = Omit<Props, "variant"> & {
  variant?: AllowedChipVariants;
  color?: ChipColor;
} & TestProps;

const Chip = ({ testId, ...props }: ChipProps) => (
  <MuiChip
    data-testid={testId}
    {...props}
    onClick={props.clickable ? props.onClick : undefined}
  />
);

export default Chip;
